import { render, staticRenderFns } from "./AdminEmprunts.vue?vue&type=template&id=5f5fc78a&scoped=true"
import script from "./AdminEmprunts.vue?vue&type=script&lang=js"
export * from "./AdminEmprunts.vue?vue&type=script&lang=js"
import style0 from "./AdminEmprunts.vue?vue&type=style&index=0&id=5f5fc78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fc78a",
  null
  
)

export default component.exports